export const sv = {
    nav: {
        overview: 'Översikt',
        cases: 'Ärenden',
        ai_visibility: 'AI Synlighet',
        dark_web: 'Dark Web',
        address: 'Adressbevaktning',
        guides: 'Guider',
        details: 'Mina Uppgifter',
        settings: 'Inställningar',
        plans: 'Planer',
        support: 'Support',
        home: 'Hem',
        how_it_works: 'Hur det fungerar',
        pricing: 'Priser',
        faq: 'Vanliga frågor',
        login: 'Logga in',
        get_started: 'Kom igång',
        dashboard: 'Dashboard',
        continue_onboarding: 'Fortsätt Onboarding',

        security: 'Säkerhet',

        reviews: 'Recensioner',
        about: 'Om oss',
        careers: 'Karriär',
        press: 'Press',
        contact: 'Kontakt',
        help_center: 'Hjälpcenter'
    },
    greeting: 'Välkommen',
    search: {
        placeholder: 'Sök på sajter...',
    },
    notifications: {
        title: 'Aviseringar',
        none: 'Inga nya aviseringar',
        time_just_now: 'Just nu',
        time_minutes: 'min sedan',
        time_hours: 'h sedan',
        time_days: 'd sedan',
        removed: 'Borttagen från',
        processing: 'Påbörjat borttagning:',
        action: 'Åtgärd krävs:',
        submitted: 'Ny förfrågan:',
        update: 'Uppdatering:'
    },
    dropdown: {
        signed_in: 'Inloggad som',
        details: 'Mina Uppgifter',
        settings: 'Inställningar',
        plans: 'Planer & Priser',
        logout: 'Logga ut',
        support: 'Support',
        appearance: 'Utseende',
        light: 'Ljust',
        dark: 'Mörkt',
        language: 'Språk',
        active: 'Aktiv'
    },
    titles: {
        dashboard: 'Dashboard',
        protection_score: 'Skyddspoäng',
        scanning: 'Skannar...',
        protection_active: 'Skydd Aktivt'
    },
    cards: {
        analysis_title: 'Din synlighet analyseras',
        analysis_text: 'Vi analyserar din synlighet på upplysningssidor och på sökmotorer. Du får en notis när analysen är klar.',
        cases_title: 'Pågående Ärenden',
        cases_desc: 'Status för dina borttagningar',
        site_status_title: 'Status på upplysningsajter',
        site_status_desc: 'Din synlighet på de största databaserna',
        status_visible: 'Synlig',
        status_protected: 'Skyddad',
        new: 'Nytt',
        no_cases: 'Inga ärenden än.',
        view_all: 'Visa alla',
        address_tab: 'Adress',
        alarm_tab: 'Larm',
        your_address: 'Din adress',
        active: 'Aktiv',
        coming_soon: 'Kommer snart',
        dev_text: 'Denna funktion är under utveckling.',
        link_removal: 'Länkborttagning'
    },
    premium_modal: {
        title: 'Lås upp Premium',
        desc: 'För att automatiskt rensa och dölja dina uppgifter från databaser och sökmotorer krävs ett aktivt Premium-abonnemang.',
        feature1: 'Borttagning från 7+ sajter',
        feature2: 'Google-avindexering',
        feature3: 'Löpande bevakning 24/7',
        feature4: 'Automatisk re-borttagning',
        button: 'Uppgradera till Premium',
        error: 'Kunde inte starta betalningen. Försök igen.',
        pro_success_title: 'Du har Noctra Pro',
        pro_success_desc: 'Dina uppgifter tas nu automatiskt bort och vi övervakar din integritet dygnet runt.',
        manage_subscription: 'Hantera prenumeration',
        portal_error: 'Kunde inte öppna kundportalen. Försök igen.'
    },
    removal_upgrade: {
        title: 'Skydda din identitet på riktigt',
        desc: 'Uppgradera till Premium för att rensa dina uppgifter från Google och 30+ andra sajter. Vi hanterar hela processen åt dig — automatiskt.',
        feature1: 'Borttagning från 7+ upplysningssajter',
        feature2: 'Google-avindexering av dina uppgifter',
        feature3: 'Löpande bevakning och re-borttagning',
        feature4: 'Personlig support och borttagningsrapport',
        button: 'Se planer & uppgradera',
        guarantee: '14 dagars ångerrätt · Avbryt när som helst'
    },
    modal: { title: 'Starta ny borttagning', desc: 'Välj vilken databas du vill ta bort dina uppgifter från.', select_site: 'Välj sida', start_btn: 'Starta borttagning', starting_btn: 'Startar...' },
    guides: {
        remove: 'Ta bort', show: 'Visa', hide: 'Dölj', step_prefix: 'Steg',
        click_remove: "Klicka på 'Ta bort'",
        enter_name: "Skriv in ditt namn i sökrutan",
        bankid: "Identifiera dig med Mobilt BankID",
        hide_details: "Dölj dina uppgifter",
        hide_address_phone: "Dölj din adress och ditt telefonnummer",
        click_hide: "Klicka på att dölja dina uppgifter",
        remove_details: "Ta bort dina uppgifter"
    },
    support: {
        title: 'Support',
        faq: 'Vanliga frågor',
        new_message: 'Nytt meddelande',
        inbox: 'Inkorg',
        no_history: 'Du har ingen meddelandehistorik',
        start_chat: 'Skriv för att börja konversationen',
        type_here: 'Skriv här...'
    },
    common: {
        view_all: 'Visa alla',
        protected: 'Skyddad',
        warning: 'Varning',
        critical: 'Kritisk',
        loading: 'Laddar...',
        recently: 'Nyligen',
        more_features: 'Fler funktioner',
        more: 'Mer',
        protect: 'Skydd',
        beta: 'Beta'
    },
    status: {
        privacy_level: 'Integritetsnivå',
        fully_protected: 'Fullt skyddad',
        partially_protected: 'Delvis skyddad',
        vulnerable: 'Sårbar',
        removed: 'Borttagen',
        processing: 'Bearbetas',
        action: 'Åtgärd krävs',
        submitted: 'Inskickad'
    },
    landing: {
        seo: {
            title: "Noctra - Ta bort dina personuppgifter från nätet",
            description: "Skydda dig mot ID-kapning och stalking. Noctra raderar dina uppgifter från Ratsit, MrKoll, Hitta.se och många fler."
        },
        hero: {
            remove: "Ta bort",
            from_web: "Från nätet med",
            subtitle: "Skydda din integritet. Vi raderar dina uppgifter från sajter som Ratsit, MrKoll och Hitta.se – automatiskt.",
            subtitle_long: "Dina personuppgifter ligger öppna på nätet. Vi hittar dem. Vi raderar dem. Och vi skyddar dig.",
            cta_start: "Sök och radera mig",
            cta_how: "Hur det fungerar",
            cta_protected: "Bli skyddad nu",
            no_binding: "Ingen bindningstid. Starta direkt.",
            trust: "Ansluten till Google Ads och Stripe för din säkerhet"
        },
        benefits: {
            title: "Varför välja Noctra?",
            subtitle: "Vi erbjuder mer än bara borttagning av data. Vi ger dig friheten att leva ditt liv utan att oroa dig för din digitala säkerhet."
        },
        social_proof: {
            secure_payment: "Betala tryggt och säkert med",
            guarantees: {
                refund: "14 dagars ångerrätt",
                cancel: "Avbryt när som helst",
                no_fees: "Inga dolda avgifter"
            }
        },
        family: {
            title: "Osynlig på nätet, trygg i verkligheten",
            subtitle: "Skydd för hela familjen, förhindra andra från att ta reda på dina privata uppgifter",
            description: "Namn, adresser, telefonnummer, familjens uppgifter och annan privat data är kontinuerligt såld utav datamäklare. Vi stoppar det.",
            protect_list_title: "Vad vi skyddar:",
            button: "Skydda familjen nu",
            tags: {
                name: "Namn",
                age: "Ålder",
                address: "Adress",
                home_value: "Bostadsvärde",
                phone: "Telefonnummer",
                mail: "Mail",
                marital_status: "Äktenskapsstatus",
                relatives: "Närstående",
                images: "Bilder",
                prev_addresses: "Tidigare adresser"
            }
        },
        knowledge_bank: {
            title: "Kunskapsbank & Guider",
            subtitle: "Lär dig hur du skyddar din digitala integritet med våra praktiska guider och artiklar",
            read_more: "Läs mer",
            read_time_suffix: "läsning",
            guides: [
                {
                    title: "5-minuters säkerhetschecklista",
                    description: "Snabba åtgärder du kan göra idag för att förbättra din digitala säkerhet markant.",
                    category: "Snabbtips"
                },
                {
                    title: "Dark Web: Hur din data hamnar där",
                    description: "Förstå hur stulna personuppgifter sprids på dark web och vad du kan göra för att skydda dig.",
                    category: "Säkerhet"
                },
                {
                    title: "Nätfiske: Så skyddar du dig",
                    description: "Lär dig känna igen phishing, smishing och vishing-attacker innan de lurar dig på dina uppgifter.",
                    category: "Säkerhet"
                }
            ]
        },
        newsletter: {
            title: "Håll dig steget före – varje vecka",
            subtitle: "Som Pro-kund får du varje vecka ett exklusivt säkerhetsnyhetsbrev med djupgående guider, aktuella hot och praktiska tips för att skydda din identitet.",
            button: "Uppgradera till Pro",
            features: [
                { text: 'Lösenordsstrategier & 2FA', icon: 'KeyRound', color: 'text-blue-400' },
                { text: 'VPN – när behöver du det?', icon: 'Wifi', color: 'text-purple-400' },
                { text: 'Backup & 3-2-1 regeln', icon: 'HardDrive', color: 'text-emerald-400' },
                { text: 'GDPR – dina rättigheter', icon: 'Shield', color: 'text-cyan-400' },
                { text: 'Aktuella bedrägerihot', icon: 'AlertTriangle', color: 'text-amber-400' },
                { text: 'Nya hot & trender', icon: 'Eye', color: 'text-rose-400' }
            ]
        },
        footer: {
            service_title: "Tjänsten",
            company_title: "Företag",
            help_title: "Hjälpmedel",
            privacy_policy: "Integritetspolicy",
            terms: "Allmänna villkor",
            cookie_policy: "Cookiepolicy",
            all_rights_reserved: "Alla rättigheter förbehållna.",
            part_of: "Noctra är en del av Lumidiom AB.",
            secure_payment: "Säker betalning"
        },
        words: {
            address: "din adress",
            phone: "ditt nummer",
            person: "dig själv",
            personal_data: "personuppgifter"
        },
        benefits_cards: {
            control_title: "Ta tillbaka kontrollen",
            control_desc: "Du bestämmer vem som ska veta var du bor. Vi ger dig makten över din data genom att radera den från offentliga register.",
            control_badge: "100% Kontroll",
            support_title: "Personlig hjälp",
            support_desc: "Inga robotar, bara riktiga människor. Vårt svenska supportteam finns här för att hjälpa dig med allt kring din säkerhet.",
            support_badge: "Premium Support"
        },
        risks: {
            title: "Dina uppgifter ligger öppna för alla",
            subtitle: "I Sverige är personuppgifter offentliga handlingar. Utan aktivt skydd kan vem som helst hitta din adress, inkomst och familjesituation på sekunder.",
            card1: {
                title: "ID-Kapning & Bedrägerier",
                desc: "Bedragare använder dina öppna uppgifter för att ta lån, beställa varor eller öppna abonnemang i ditt namn."
            },
            card2: {
                title: "Stalking & Hot",
                desc: "Ditt hem ska vara din borg. Offentliga adresser gör det enkelt för obehöriga att söka upp dig och din familj."
            },
            card3: {
                title: "Spam & Telefonförsäljare",
                desc: "Dina uppgifter säljs till företag som bombar dig med reklam. Vi stryper flödet vid källan."
            }
        },
        pricing_section: {
            title: "Börja skydda dig idag",
            subtitle: "Välj den plan som passar dig bäst",
            yearly: "Årsplan",
            monthly: "Månadsvis",
            save_text: "Spara upp till 16%",
            pro_exclusive: "Ingår i Pro",
            guarantee: "14 dagars ångerrätt · Avbryt när som helst",
            bas_title: "Bas",
            pro_title: "Pro",
            onetime_title: "Behöver du bara fixa det en gång?",
            onetime_desc: "Vi tar bort dina uppgifter från alla sajter och skickar en rapport med bevis. Ingen prenumeration.",
            onetime_btn: "Engångsrensning — 99 kr",
            cta: "Bli skyddad nu",
            best_value: "Bäst värde",
            save_badge: "Du sparar",
            per_person: "Bara {price} kr/person",
            month_unit: "mån",
            year_unit: "år",
            add_family: "Lägg till familjemedlemmar (+29 kr/mån)",
            payment_error: "Kunde inte starta betalningen. Försök igen.",
            no_commitment: "Ingen bindningstid",
            features: {
                google_removal: "Google-avindexering (5 länkar)",
                google_removal_pro: "Google-avindexering (10 länkar)",
                personal_support: "Personlig support",
                priority_support: "Prioriterad support",
                no_commitment: "Ingen bindningstid",
                darkweb_monitoring: "Dark Web-bevakning",
                ai_visibility: "AI Synlighet (ChatGPT, Gemini m.fl.)",
                one_person: "1 Person",
                two_persons: "2 Personer ingår",
                removal_7_sites: "Borttagning från 7+ upplysningssajter",
                removal_report: "Borttagningsrapport med bevis",
                monitoring_24_7: "Löpande bevakning 24/7",
                auto_removal: "Automatisk re-borttagning",
                address_alarm: "Adresslarm",
                dashboard: "Noctra Dashboard",
                all_basic_included: "Allt i Bas ingår",
                protection_1_person: "Löpande skydd — 1 person",
                protection_2_persons: "Maximalt skydd — 2 personer inkl."
            }
        },
        cta_section: {
            title: "Sluta oroa dig över dina personuppgifter",
            subtitle: "Ta kontroll över din digitala integritet idag. Det tar bara 2 minuter att komma igång med Noctra.",
            button: "Kom igång nu"
        },
        footer_info: {
            description: "Noctra hjälper dig att ta kontroll över din digitala integritet genom att automatiskt ta bort dina personuppgifter från nätet.",
            powered_by: "Drivs av",
            org_nr: "Org.nr"
        },
        faq: {
            categories: {
                all: "Alla frågor",
                getting_started: "Kom igång",
                subscription: "Prenumeration",
                privacy: "Integritet",
                account: "Kontoinställningar",
                notifications: "Notiser",
                security: "Säkerhet",
                support: "Support"
            },
            items: [
                {
                    question: "Vad gör Noctra?",
                    answer: "Noctra hjälper dig att ta bort dina personuppgifter från upplysningssajter som Ratsit, Hitta.se, MrKoll, Eniro och många fler. Vi hanterar processen åt dig och övervakar kontinuerligt så att dina uppgifter inte dyker upp igen."
                },
                {
                    question: "Hur lång tid tar det innan mina uppgifter är borttagna?",
                    answer: "De flesta sajter tar bort dina uppgifter inom 1-4 veckor. Vissa sajter kan ta längre tid beroende på deras interna processer. Du kan följa statusen i din instrumentpanel."
                },
                {
                    question: "Vilka sajter täcker ni?",
                    answer: "Vi täcker alla större svenska upplysningssajter: Ratsit, Hitta.se, MrKoll, Eniro, Merinfo, Birthday.se, och många fler. Listan uppdateras kontinuerligt."
                },
                {
                    question: "Är det lagligt att ta bort sina uppgifter?",
                    answer: "Ja, absolut! Enligt GDPR har du rätt att begära radering av dina personuppgifter. Noctra hjälper dig att utöva denna rättighet."
                },
                {
                    question: "Vad kostar Noctra?",
                    answer: "Vi erbjuder olika paket från 29 kr/månad vid årsbetalning. Du kan se alla våra priser på startsidan. Vi erbjuder även en kostnadsfri sökning så du kan se var dina uppgifter finns."
                },
                {
                    question: "Kan jag avbryta min prenumeration?",
                    answer: "Ja, du kan avbryta din prenumeration när som helst utan bindningstid. Ditt skydd fortsätter till slutet av din betalningsperiod."
                },
                {
                    question: "Hur vet jag att det fungerar?",
                    answer: "Du får automatiska uppdateringar via e-post och kan följa all aktivitet i din instrumentpanel i realtid. Vi visar exakt vilka sajter vi kontaktat och vilka som bekräftat borttagning."
                },
                {
                    question: "Hur hanterar ni mitt personnummer?",
                    answer: "Vi behandlar ditt personnummer säkert och krypterat enbart för att kunna identifiera dig i databaser och begära borttagning. Vi delar det aldrig med obehöriga."
                },
                {
                    question: "Hur ändrar jag mina kontouppgifter?",
                    answer: "Du kan enkelt ändra dina kontouppgifter genom att logga in på din instrumentpanel och gå till Inställningar. Där kan du uppdatera e-post, lösenord och andra profilinställningar."
                },
                {
                    question: "Vilka betalningsmetoder accepterar ni?",
                    answer: "Vi accepterar alla större betalningsmetoder: Visa, Mastercard, Klarna, PayPal, Apple Pay och Google Pay. Alla betalningar sker säkert via Stripe."
                },
                {
                    question: "Hur kontaktar jag supporten?",
                    answer: "Du kan kontakta vår support via e-post eller genom chattfunktionen i din dashboard. Vi svarar normalt inom 24 timmar på vardagar."
                },
                {
                    question: "Hur ofta söker ni efter mina uppgifter?",
                    answer: "Vi gör kontinuerliga sökningar för att säkerställa att dina uppgifter inte dyker upp igen. Premium-kunder får löpande bevakning med direktnotiser."
                }
            ],
            guides_title: "Se gärna våra guider",
            guides_subtitle: "Lär dig mer om hur du kan skydda din integritet online.",
            guides: [
                {
                    title: "Registreringsguide",
                    description: "Enkel guide för att komma igång med ditt konto efter köp."
                },
                {
                    title: "Användningsguide",
                    description: "Allt du behöver veta om hur du använder Noctra."
                },
                {
                    title: "Så funkar det",
                    description: "Ta reda på hur vår tjänst fungerar och vilka sajter vi hanterar."
                },
                {
                    title: "Samarbeten",
                    description: "Ta kontakt med oss för ett säkrare och mer ansvarsfullt samarbete."
                }
            ],
            hero: {
                title: "Vanliga Frågor",
                subtitle: "Här hittar du svar på de vanligaste frågorna om hur våra tjänster fungerar och vad du kan förvänta dig av vår tjänst. Om du inte hittar svaret du söker är du alltid välkommen att kontakta oss!",
                filter_title: "Vad vill du veta mer om?"
            },
            contact_cta: {
                title: "Hittar du inte svaret på din fråga?",
                subtitle: "Vårt supportteam finns här för att hjälpa dig. Kontakta oss så svarar vi så snart vi kan.",
                button: "Kontakta oss",
                home_button: "Gå till startsidan"
            }
        }
    },
    auth: {
        login: {
                title: "Välkommen tillbaka",
                subtitle: "Logga in på ditt konto",
                google: "Logga in med Google",
                apple: "Logga in med Apple",
                email_btn: "Logga in med E-post",
                or: "eller",
                no_account: "Har du inget konto?",
                signup_link: "Kom igång",
                email_label: "E-post",
                password_label: "Lösenord",
                forgot_password: "Glömt lösenord?",
                back: "Tillbaka till inloggningsalternativ",
                submit: "Logga in",
                loading: "Loggar in...",
                errors: {
                    generic: "Ett fel uppstod",
                    no_email: "Ange din e-postadress först",
                    check_email: "Kolla din e-post för återställningslänk!"
                }
            },
            signup: {
                title: "Skapa konto",
                subtitle: "Kom igång och skydda din integritet",
                google: "Fortsätt med Google",
                apple: "Fortsätt med Apple",
                email_btn: "Fortsätt med E-post",
                has_account: "Har du redan ett konto?",
                login_link: "Logga in",
                back: "Tillbaka till registreringsalternativ",
                submit: "Skapa konto",
                loading: "Skapar konto...",
                success: "Kolla din e-post för att bekräfta ditt konto!",
                errors: {
                    invalid_email: "Ange en giltig e-postadress",
                    password_length: "Lösenordet måste vara minst 6 tecken.",
                    signups_disabled: "Det går inte att registrera nya konton just nu.",
                    generic: "Kunde inte skapa kontot. Vänligen försök igen."
                }
            },
            footer: {
                agree: "Genom att fortsätta godkänner du våra",
                terms: "användarvillkor",
                and: "samt att du får periodiska e-postutskick med uppdateringar och att du läst vår",
                privacy: "integritetspolicy"
            },
            visual: {
                title: "Din integritet, dina villkor",
                description: "Vi raderar dina spår från nätet så att du kan leva utan att någon obehörig har tillgång till dina uppgifter.",
                alt: "Noctra-appen på en smartphone"
            }
        },
        onboarding: {
            title: "Välkommen till Noctra! 👋",
            subtitle: "För att vi ska kunna skydda dig och ta bort dina uppgifter behöver vi veta vem du är. Dina uppgifter krypteras och används endast för borttagning.",
            seo_title: "Kom igång - Noctra",
            seo_desc: "Skapa ditt konto och välj plan för att börja ta bort dina uppgifter från nätet.",
            steps: { verify: "Verifiera", name: "Namn", country: "Land", address: "Adress", plan: "Plan" },
            step1: {
                title_verify: "Verifiera konto",
                title_signup: "Registrera dig",
                subtitle_verify: "Bekräfta din e-postadress för att fortsätta med din setup.",
                subtitle_signup: "Ange din e-postadress för att skapa ditt konto säkert, helt utan lösenord.",
                email_label: "E-postadress",
                continue_btn: "Fortsätt",
                no_sell: "Vi säljer aldrig dina uppgifter",
                verify_email_title: "Verifiera e-post",
                verify_email_subtitle1: "Vi har skickat en 6-siffrig kod till ",
                verify_email_link_subtitle1: "Vi har skickat en bekräftelselänk till ",
                verify_email_subtitle2: ". Ange koden nedan.",

                verifying: "Verifierar kod...",
                send_new: "Skicka ny kod",
                send_new_in: "Skicka ny kod om",
                change_email: "Ändra e-postadress?",
                err_invalid_email: "Ange en giltig e-postadress",
                err_no_signup: "Det går inte att registrera nya konton just nu.",
                err_send: "Kunde inte skicka koden. Vänligen försök igen.",
                err_invalid_code: "Ogiltig eller utgången kod. Vänligen försök igen.",
                check_inbox: "Klicka på länken i mailet för att verifiera ditt konto.",
                waiting_confirm: "Väntar på verifiering..."

            },
            step2: {
                title: "Ditt namn",
                subtitle: "Ange ditt fullständiga namn",
                err_full_name: "Ange både för- och efternamn",
                err_save: "Kunde inte spara namnet. Fel: ",
                placeholder: "För- och efternamn"
            },
            step3: {
                title: "Vilket land bor du i?",
                subtitle: "Vi anpassar våra sökningar baserat på din region.",
                sweden: "Sverige",
                norway: "Norge",
                denmark: "Danmark",
                finland: "Finland",
                err_save: "Kunde inte spara land. Fel: "
            },
            step4: {
                title: "Var bor du?",
                subtitle: "Denna information används för att skanna databaser och offentliga register efter dina uppgifter.",
                street: "Gatuadress & Nummer",
                zip: "Postnummer",
                city: "Ort",
                street_ph: "Ange gatuadress",
                zip_ph: "Ange postnummer",
                city_ph: "Ange ort",
                err_save: "Kunde inte spara adressen. Fel: "
            },
            step5: {
                title: "Välj din plan",
                subtitle: "Du kan alltid uppgradera eller ändra plan senare",
                yearly: "Årsplan",
                save: "Spara 16%",
                monthly: "Månadsvis",
                no_binding: "Ingen bindningstid",
                err_payment: "Kunde inte starta betalningen. Försök igen.",
                onetime_title: "Behöver du bara fixa det en gång?",
                onetime_desc: "Vi tar bort dina uppgifter och skickar en rapport. Ingen prenumeration.",
                onetime_btn: "Engångsrensning — 99 kr",
                guarantee: "Alla planer inkluderar 14 dagars ångerrätt. Du kan avbryta när som helst.",
                free: {
                    period: "Alltid gratis",
                    description: "Kom igång och utforska din digitala synlighet",
                    features: ["Noctra Dashboard", "Se din integritetsnivå", "Steg-för-steg guider", "Support via chatt"],
                    cta: "Börja gratis"
                },
                bas: {
                    period: "kr/mån",
                    description: "Löpande skydd — vi hanterar borttagningen åt dig",
                    features: ["Allt i Free", "Borttagning från 6+ sajter", "Länkborttagning & Google-avindexering", "Adresslarm dygnet runt", "Ärendehantering med status"],
                    cta: "Välj Bas"
                },
                pro: {
                    period: "kr/mån",
                    description: "Maximalt skydd med Dark Web & AI-scanning",
                    badge: "Populärast",
                    features: ["Allt i Bas", "Dark Web-scanning", "AI Synlighet (ChatGPT, Gemini m.fl.)", "GDPR-borttagning från AI-tjänster", "Veckovis säkerhetsrapport"],
                    cta: "Välj Pro"
                }
            }
        },
        demos: {
            title: "Se hur Noctra fungerar i praktiken",
            tabs: {
                monitoring: { title: "Dygnet runt bevakning", desc: "Skannar nätet efter nya hot" },
                removal: { title: "Radera spår", desc: "Döljer dig från sökresultat" },
                alerts: { title: "Skyddslarm", desc: "Få notis om vi hittar något" },
                google: { title: "Avindexering", desc: "Tas bort från Google snabbt" }
            },
            control: {
                protected: "Skyddad",
                public: "Offentlig",
                hidden: "Dold för allmänheten",
                visible_hitta: "Synlig på Hitta.se",
                visible_eniro: "Synlig på Eniro",
                profile: "Din Profil",
                home_address: "Hemadress",
                phone: "Telefonnummer"
            },
            scan: {
                recognize: "Analys känner igen:",
                ratsit: "Ratsit profil",
                mrkoll: "MrKoll adress",
                eniro: "Eniro telefon",
                scanning: "Skannar databaser...",
                identifying: "Identifierar data...",
                search_ratsit: "Letar på Ratsit...",
                search_mrkoll: "Söker på MrKoll...",
                search_eniro: "Söker på Eniro...",
                search_hitta: "Söker på Hitta.se...",
                found: "hittade",
                protected: "skyddade"
            },
            google: {
                removed: "Borttagen från Google",
                reason: "Result avindexerat enligt begäran för integritet",
                desc: "Information borttagen och ej tillgänglig...",
                removed_result: "Borttaget resultat",
                your_profile: "Din Profil",
                all_removed: "Alla resultat borta!",
                invisible: "Din profil är nu osynlig på sökmotorer."
            },
            notification: {
                new_finding: "Nytt FYND",
                finding_desc: "Vi upptäckte dina uppgifter på",
                new_change: "Ny ÄNDRING",
                change_desc: "Din adress har ändrats utanför vårt system",
                deleted: "Raderad från",
                deleted_desc: "Dina uppgifter är nu helt borttagna från",
                done: "Klar",
                protection_active: "Skydd aktivt",
                all_updated: "Alla ärenden uppdaterade",
                activity: "Aktivitet",
                live: "Live",
                searching: "Söker dina uppgifter...",
                sources_found: "12 källor identifierade",
                sending_ratsit: "Skickar begäran till Ratsit",
                removed_ratsit: "Borttagen från Ratsit",
                sending_hitta: "Skickar till Hitta.se",
                removed_hitta: "Borttagen från Hitta.se",
                clearing_google: "Rensar Google-sökning",
                removed_google_link: "Google-länk borttagen",
                done_status: "Klar",
                processing_status: "Pågår",
                now: "nu",
                all_removed_notif: "✅ Alla uppgifter borttagna! Du är nu skyddad."
            },
            removal: {
                age: "Ålder: 42 år",
                salary_btn: "Kolla Lars lön anonymt",
                ssn_label: "Personnummer:",
                remove: "Ta bort",
                identifying: "Identifierar",
                removed: "Borttagen"
            },
            mockups: {
                greeting: "Hej Lars 👋",
                privacy_level: "Integritetsnivå",
                fully_protected: "Fullt skyddad",
                information_sites: "Upplysningssidor",
                removed: "Borttagen",
                cases_title: "Pågående Ärenden",
                just_now: "Just nu",
                in_queue: "I kö",
                google_link: "Google-länk",
                support: {
                    agent_greeting: "Hej! 👋 Jag är Robin, din personliga rådgivare. Hur kan jag hjälpa dig?",
                    agent_role: "Robin från Noctra",
                    online: "Online",
                    user_msg: "Behöver jag göra något mer efter att ni tagit bort mina uppgifter?",
                    agent_reply: "Nej, bara slappna av! 😊 Vi sköter all bevakning och rensning automatiskt. Du får en notis om något nytt dyker upp."
                }
            },
            carousel: {
                title_1: "Vi hittar dina uppgifter",
                desc_1: "Vi skannar nätet och identifierar var dina personuppgifter finns publicerade offentligt — även på sidor du inte visste fanns.",
                title_2: "Vi tar bort dem",
                desc_2: "Vi skickar automatiska borttagningsbegäran till sidor som Hitta.se, MrKoll, Ratsit och många fler databaser.",
                title_3: "Följ processen i realtid",
                desc_3: "Du får notiser direkt i telefonen för varje steg i processen, från identifiering till bekräftad borttagning.",
                title_4: "Bli osynlig på sökningar",
                desc_4: "Vi ser till att dina uppgifter försvinner från Google och andra sökmotorer så att ingen kan söka upp dig."
            }
        },
        address_monitoring: {
            premium_title: 'Adresslarm — Premium',
            premium_desc: 'Som premiumanvändare bevakar vi din adress dygnet runt och varnar dig direkt om någon obehörig försöker skriva sig på din adress.',
            view_plans: 'Se våra planer',
            activate_title: 'Aktivera Adresslarmet',
            activate_desc: 'Få en notis direkt om någon försöker ändra din folkbokföringsadress. Vi bevakar Skatteverket och SPAR dygnet runt.',
            feature_alert: 'Direktlarm',
            feature_alert_desc: 'SMS & Email vid ändringar',
            feature_monitor: '24/7 Bevakning',
            feature_monitor_desc: 'Realtidskontroll mot register',
            feature_block: 'Spärrtjänst',
            feature_block_desc: 'Hjälp att stoppa kapningen',
            activate_btn: 'Aktivera Skyddet Nu',
            activating: 'Aktiverar...',
            loading: 'Laddar...',
            alert_header: '🚨 INKRÄKTARE UPPTÄCKT!',
            alert_desc: 'Okänd person har registrerat sig på din adress. Kontrollera din email för detaljer.',
            status_title: 'Adresslarm Status',
            status_active: 'Bevakning aktiv',
            status_monitored: 'Din adress övervakas i realtid',
            check_btn: 'Kontrollera Nu',
            checking: 'Kontrollerar...',
            address_label: 'Din Folkbolföringsadress',
            monitored_since: 'Bevakad sedan',
            settings_title: 'Avancerade Inställningar',
            settings_desc: 'Konfigurera inkräktar-skydd för lägenheter och familj',
            apt_label: 'Lägenhetsnummer (valfritt)',
            apt_placeholder: 't.ex. 1101',
            apt_desc: 'Om du bor i lägenhet, ange ditt lägenhetsnummer för att upptäcka obehöriga registreringar',
            whitelist_label: 'Godkända Sambor/Familj (valfritt)',
            whitelist_placeholder: 't.ex. Maria Svensson, Erik Andersson',
            whitelist_desc: 'Ange namn separerade med kommatecken. Systemet varnar inte om dessa personer bor på din adress.',
            save_btn: 'Spara Inställningar',
            saving: 'Sparar...',
            toast_success: 'Adresslarm aktiverat!',
            toast_error: 'Kunde inte aktivera bevakning.',
            toast_generic_error: 'Ett fel uppstod.',
            toast_fill_address: 'Fyll i din adress under "Mina Uppgifter" först.',
            toast_check_failed: 'Kontroll misslyckades.',
            toast_check_error: 'Kunde inte köra kontroll.',
            toast_settings_saved: 'Inställningar sparade!',
            toast_settings_error: 'Kunde inte spara inställningar.',
            protection_status_safe: 'Din adress är skyddad',
            protection_status_alert: 'VARNING: Ändring upptäckt!',
            last_checked: 'Senast kontrollerad',
            active_badge: 'AKTIV',
            alarm_badge: 'LARM',
            monitored_address_label: 'Bevakad Adress',
            report_agency: 'Anmäl till Skatteverket →'
        },
        ai_visibility: {
            title: 'AI Synlighet',
            subtitle: 'Vi kontrollerar manuellt om dina personuppgifter förekommer i svar från populära AI-tjänster.',
            requestScan: 'Begär scanning',
            requesting: 'Skickar...',
            alreadyRequested: 'Scanning pågår',
            scanPending: 'Vi har tagit emot din begäran. Vårt team granskar nu varje AI-tjänst manuellt — du får en notis när resultaten är klara.',
            scanCompleted: 'Scanning slutförd',
            servicesChecked: 'tjänster kontrollerade',
            exposures: 'exponeringar hittade',
            removals: 'borttagningar',
            noDataFound: 'Ingen data hittad',
            dataFound: 'Data hittad',
            remove: 'Ta bort',
            ignore: 'Ignorera',
            details: 'Detaljer',
            requestedAt: 'Begärd',
            completedAt: 'Klar',
            infoText: 'Noctra kontrollerar manuellt dina exponeringar i ChatGPT, Google Gemini, Claude, Microsoft Copilot och Perplexity. Om vi hittar dina personuppgifter kan du välja att begära borttagning — vi sköter hela GDPR-processen åt dig.',
            noScanYet: 'Du har inte begärt en AI-scanning ännu. Klicka nedan för att låta oss granska dina exponeringar.',
            removed: 'Borttagen',
            removalRequested: 'Begärd',
            premiumTitle: 'AI Synlighet — Premium',
            premiumDesc: 'Som premiumanvändare letar vi upp och tar bort dina personuppgifter från ChatGPT, Gemini och andra stora AI-modeller.',
            viewPlans: 'Se våra planer',
            errorRequest: 'Kunde inte skicka begäran. Försök igen.',
            refresh: 'Uppdatera',
            scanning: 'Skannas',
            found: 'Hittad',
            not_found: 'Ej hittad',
            in_progress: 'Pågår',
            ignored: 'Ignorerad'
        },
        dark_web: {
            title: 'Dark Web-scanning',
            subtitle: 'Vi kontrollerar om dina personuppgifter har läckt i kända dataintrång.',
            scan: 'Starta scanning',
            scanning: 'Skannar...',
            rescan: 'Skanna igen',
            lastScan: 'Senaste scanning',
            breachesFound: 'läckor hittade',
            noBreaches: 'Inga läckor hittade',
            exposedData: 'Exponerad data',
            severity: 'Allvarlighetsgrad',
            high: 'Hög',
            critical: 'Kritisk',
            medium: 'Medel',
            recommendation: 'Rekommendation',
            changePassword: 'Byt lösenord omedelbart',
            monitorAccount: 'Bevaka detta konto',
            enable2fa: 'Aktivera tvåfaktorsautentisering',
            totalExposures: 'Totala exponeringar',
            passwordLeaks: 'Lösenordsläckor',
            scannedEmail: 'Skannad e-post',
            source: 'Källa',
            indicative: 'Indikativ (ej bekräftad match)',
            affectedAccounts: 'påverkade konton',
            history: 'Scan-historik',
            infoText: 'Resultaten baseras på data från Have I Been Pwned (HIBP) — världens största databas för dataintrång.',
            leaks: 'läckor',
            passwords: 'lösenord',
            security_priority: 'Säkerhet är vår prioritet',
            all_data_checked: 'All data kontrolleras mot autentiska källor från det mörka nätet och kända intrång.',
            premiumTitle: 'Dark Web-scanning — Premium',
            premiumDesc: 'Som premiumanvändare övervakar vi dina uppgifter dygnet runt och varnar dig direkt om vi hittar dina uppgifter i nya läckor.',
            viewPlans: 'Se våra planer',
            searchTitle: 'Sök efter din e-post',
            accounts: 'konton',
            scanFailed: 'Skanningen misslyckades'
        },
        link_removal: {
            title: 'Begär länkborttagning',
            subtitle: 'Klistra in en länk du vill ta bort från webben eller sökmotorer',
            url_label: 'URL att ta bort',
            url_placeholder: 'https://exempel.se/sida-med-dina-uppgifter',
            type_label: 'Typ av borttagning',
            type_search: 'Sökmotor',
            type_search_desc: 'Ta bort från Google, Bing etc.',
            type_website: 'Webbsida',
            type_website_desc: 'Ta bort från en specifik webbplats',
            desc_label: 'Beskrivning (valfritt)',
            desc_placeholder: 'Beskriv varför du vill ta bort denna länk, t.ex. vilken information som visas...',
            submit: 'Skicka begäran',
            submitting: 'Skickar...',
            success: 'Din begäran har skickats!',
            success_desc: 'Vi behandlar din begäran och meddelar dig när det är klart.',
            history_title: 'Dina begäranden',
            history_empty: 'Du har inga aktiva begäranden',
            history_empty_desc: 'Dina länkborttagningsförfrågningar visas här.',
            status_submitted: 'Inskickad',
            status_processing: 'Bearbetas',
            status_removed: 'Borttagen',
            status_action: 'Åtgärd krävs',
            invalid_url: 'Ange en giltig URL (börja med http:// eller https://)',
            new_request: 'Ny begäran',
            processing_time: 'Vi behandlar din begäran inom 1-3 arbetsdagar',
            future_cases: 'Dina framtida ärenden visas här.',
            premiumTitle: 'Premiumbaserad tjänst',
            premiumDesc: 'Som premiumanvändare kan du begära borttagning av personuppgifter från Google och andra webbplatser automatiskt.',
            viewPlans: 'Se våra planer'
        },
        my_details: {
            title: 'Personlig Information',
            verified: '✓ Verifierad',
            full_name: 'För- och efternamn',
            ssn: 'Personnummer',
            ssn_desc: 'Kan ej ändras manuellt.',
            ssn_title: 'Kontakta support för att ändra personnummer',
            email: 'E-postadress',
            phone: 'Telefonnummer',
            address: 'Adress',
            zip_code: 'Postnummer',
            city: 'Ort',
            save: 'Spara ändringar',
            saving: 'Sparar...',
            success: 'Uppgifter sparade!',
            error: 'Kunde inte spara: ',
        },
        settings: {
            title: 'Inställningar',
            subscription: 'Prenumeration',
            next_billing: 'Nästa dragning',
            active: 'Aktiv',
            manage_billing: 'Hantera betalningar hos Stripe',
            notifications: 'Aviseringar',
            email_notif: 'E-post vid nya ärenden',
            email_notif_desc: 'Få ett mail när vi hittar nya uppgifter om dig.',
            weekly_report: 'Veckorapport',
            weekly_report_desc: 'Sammanfattning av din säkerhetsstatus.',
            security: 'Säkerhet & Konto',
            password: 'Lösenord',
            password_desc: 'Återställ ditt lösenord via e-post.',
            change_password: 'Byt lösenord',
            sending: 'Skickar...',
            delete_account: 'Radera konto',
            delete_confirm: 'Är du säker på att du vill radera ditt konto? Detta går inte att ångra.',
            delete_support: 'Kontakta support@noctra.se för att avsluta ditt konto.',
            portal_opening: 'Öppnar Stripe Customer Portal...',
            portal_error: 'Kunde inte öppna kundportalen. Kontakta support.',
            password_error: 'Kunde inte skicka återställningslänk: ',
            password_sent: 'En återställningslänk har skickats till din e-post!',
            unexpected_error: 'Ett oväntat fel uppstod.',
            cancels_on: 'Avbryts den',
            cancelling: 'Avbryter...'
        },
        profile: {
            email_enabled: 'E-postnotiser aktiverade',
            email_disabled: 'E-postnotiser inaktiverade',
            weekly_enabled: 'Veckorapport aktiverad',
            weekly_disabled: 'Veckorapport inaktiverad',
        },
        plans_page: {
            title: 'Välj din plan',
            subtitle: 'Uppgradera för att få fullt skydd och löpande bevakning.',
            premium_active_title: 'Du har en aktiv plan!',
            premium_active_desc: 'Tack för att du använder vår tjänst. Dina funktioner är upplåsta och aktiva på ditt konto. Du behöver inte välja någon ny plan.',
            premium_active_badge: 'AKTIV',
            yearly: 'Årsplan',
            save: 'Spara 16%',
            monthly: 'Månadsvis',
            onetime_title: 'Behöver du bara fixa det en gång?',
            onetime_desc: 'Vi gör en fullständig rensning och skickar en rapport. Ingen prenumeration.',
            onetime_btn: 'Engångsrensning — 99 kr',
            most_popular: 'Mest populär',
            month_suffix: '/mån',
            year_suffix: 'kr / år',
            current_plan: 'Din nuvarande plan',
            choose_plan: 'Välj plan',
            payment_error: 'Kunde inte starta betalningen. Försök igen.',
            trust: {
                payment: 'Säker betalning',
                id: 'ID-Skydd',
                support: 'Premium Support',
                commitment: 'Ingen bindningstid'
            },
            bas: {
                users: "Löpande skydd — 1 person",
                features: [
                    "1 Person",
                    "Borttagning från 7+ upplysningssajter",
                    "Google-avindexering (5 länkar)",
                    "Borttagningsrapport med bevis",
                    "Löpande bevakning 24/7",
                    "Automatisk re-borttagning",
                    "Adresslarm",
                    "Noctra Dashboard"
                ]
            },
            pro: {
                users: "Maximalt skydd — 2 personer inkl.",
                features: [
                    "2 Personer ingår",
                    "Allt i Bas ingår",
                    "Dark Web-bevakning",
                    "AI Synlighet (ChatGPT, Gemini m.fl.)",
                    "Google-avindexering (10 länkar)",
                    "Lägg till familjemedlemmar (+29 kr/mån)",
                    "Prioriterad support"
                ]
            }
        },
        support_page: {
            title: 'Hjälp & Support',
            subtitle: 'Vi finns här för att hjälpa dig med din integritet.',
            contact_us: 'Kontakta oss',
            thanks: 'Tack för ditt meddelande!',
            thanks_desc: 'Vi återkommer till dig via e-post så snart vi kan, oftast inom 24 timmar.',
            send_new: 'Skicka ett nytt meddelande',
            subject: 'Ämne',
            select_subject: 'Välj ämne...',
            subject_case: 'Fråga om ärende',
            subject_billing: 'Faktura & Betalning',
            subject_tech: 'Tekniskt problem',
            subject_other: 'Övrigt',
            message: 'Meddelande',
            placeholder: 'Beskriv ditt ärende här...',
            send_btn: 'Skicka meddelande',
            sending: 'Skickar...',
            live_chat: 'Direktmeddelande',
            chat_desc: 'Skriv direkt till vårt team. Vi svarar vanligtvis inom 1 timme.',
            online: 'Vi är online nu',
            faq: 'Vanliga frågor',
            see_all: 'Se alla frågor',
            error_send: 'Kunde inte skicka meddelandet. Försök igen.',
            error_unexpected: 'Ett oväntat fel uppstod.',
            faq_q1: "Hur lång tid tar en borttagning?",
            faq_a1: "De flesta borttagningar sker inom 1-2 veckor. Vissa sidor som MrKoll kan ta upp till 30 dagar då de kräver manuell handläggning.",
            faq_q2: "Kommer mina uppgifter tillbaka?",
            faq_a2: "Vi bevakar sidorna kontinuerligt. Om dina uppgifter dyker upp igen får du ett larm och vi påbörjar en ny borttagning automatiskt.",
            faq_q3: "Vad ingår i min prenumeration?",
            faq_a3: "Du får obegränsade borttagningar från alla anslutna databaser, identitetsbevakning i realtid och prioriterad support."
        },
        
        how_it_works: {
            hero: {
                title: 'Hur det funkar',
                subtitle: 'Skydda din integritet på nätet i fyra enkla steg. Vi tar hand om allt åt dig.'
            },
            steps: {
                step1: {
                    title: 'Välj plan',
                    description: 'Jämför och välj den plan som passar dig bäst, baserat på hur många person som ska skyddas. Alla våra paket inkluderar obegränsad länkborttagning samt borttagning från upplysningssidor.',
                    cta: 'Se våra planer'
                },
                step2: {
                    title: 'Aktivera ditt konto',
                    description: 'Efter att du valt önskad plan och genomfört ditt köp, får du ett aktiveringsmejl.',
                    phone: {
                        title: 'Aktivera ditt konto',
                        greeting: 'Hej Axel',
                        desc: 'Ditt konto har skapats och du kan nu logga in för att aktivera ditt konto.'
                    }
                },
                step3: {
                    title: 'Borttagning',
                    description: 'I ditt konto kan du direkt ta bort dig från olika upplysningssidor direkt. Vi tar bort dig från MrKoll och tar bort dina länkar från Google. Du kan följa hela processen direkt i appen.',
                    phone_status: 'Borttagningsstatus',
                    phone_found: 'Hittad',
                    phone_removed: 'Borttagen'
                },
                step4: {
                    title: 'Bevakning',
                    description: 'Vår bevakning håller koll ifall nya länkar om dig skulle dyka upp. Du får då en notis i appen och kan direkt välja om du önskar att vi tar bort länken.',
                    phone_active: 'Bevakning aktiv',
                    phone_last: 'Senast: Just nu',
                    phone_protected: 'Skyddad',
                    phone_scanning: 'Skannar källor',
                    phone_scanning_status: 'Skannar...',
                    phone_results: 'Inga nya träffar hittade'
                }
            },
            pricing: {
                title: 'Dölj dina uppgifter och bli skyddad nu',
                subtitle: 'Välj den plan som passar dig bäst',
                yearly: 'Årsplan',
                save: 'Spara upp till 16%',
                monthly: 'Månadsvis',
                guarantee: '14 dagars ångerrätt · Avbryt när som helst',
                swipe: '← Svep för att se båda planerna →',
                onetime_title: 'Behöver du bara fixa det en gång?',
                onetime_desc: 'Vi tar bort dina uppgifter från alla sajter och skickar en rapport med bevis.',
                onetime_btn: 'Engångsrensning — 99 kr',
                best_value: 'Bäst värde',
                mo: 'mån',
                yr: 'år',
                no_binding: 'Ingen bindningstid',
                you_save: 'Du sparar',
                only: 'Bara',
                per_person: 'kr/person',
                get_protected: 'Bli skyddad nu',
                loading: 'Laddar...'
            },
            trust: {
                payment: 'Betala tryggt och säkert med',
                guarantee: '14 dagars ångerrätt',
                cancel: 'Avbryt när som helst',
                no_fees: 'Inga dolda avgifter'
            },
            newsletter: {
                badge: 'Ingår i Pro',
                title: 'Håll dig steget före – varje vecka',
                desc: 'Som Pro-kund får du varje vecka ett exklusivt säkerhetsnyhetsbrev med djupgående guider, aktuella hot och praktiska tips för att skydda din identitet.',
                cta: 'Uppgradera till Pro',
                topics: [
                    'GDPR – dina rättigheter',
                    'Aktuella bedrägerihot',
                    'Nya hot & trender',
                    'Veckovis säkerhetsrapport'
                ]
            },
            footer: {
                rights: 'Alla rättigheter förbehållna.'
            }
        },
        cases_page: {
            site: 'Databas / Sida',
            status: 'Status',
            updated: 'Senast uppdaterad',
            details: 'Detaljer',
            no_cases: 'Inga ärenden än',
            no_cases_desc: 'Dina ärenden kommer att dyka upp här så fort vi börjar skanna.',
            id: 'Ärende-ID',
            created: 'Skapad',
            type: 'Typ',
            website: 'Webbplats',
            description: 'Beskrivning',
            status_removed: 'Borttagen',
            status_processing: 'Bearbetas',
            status_action: 'Åtgärd krävs',
            status_submitted: 'Inskickad',
            status_unknown: 'Okänd status',
            type_new: 'Ny förfrågan',
            type_processing: 'Under behandling',
            type_completed: 'Slutförd',
            type_action: 'Åtgärd krävs',
            type_other: 'Övrigt',
            id_label: 'ID'
    },
    poa: {
        nav_label: 'Fullmakt',
        title: 'Fullmakt',
        subtitle: 'För att vi ska kunna agera å dina vägnar behöver du signera en digital fullmakt.',
        legal_body_1: 'Härmed ger jag, undertecknad, Lumidiom AB (org.nr 559438-1647) fullmakt att företräda mig i samtliga ärenden rörande radering, begränsning och hantering av mina personuppgifter.',
        legal_body_2: 'Denna fullmakt omfattar kontakt med sökmotorer (såsom Google, Bing) och leverantörer av söktjänster (såsom MrKoll, Ratsit, Hitta.se, Eniro, Lexbase, Krimfup m.fl.). Ombudet har rätt att å mina vägnar begära radering enligt GDPR artikel 17 samt göra invändningar enligt GDPR artikel 21.',
        verification_title: 'Verifiering',
        verification_body: 'Detta dokument signeras digitalt via Noctra Verification System. Tidpunkt, IP-adress och identitetsverifiering registreras automatiskt vid signering.',
        checkbox_label: 'Jag har läst och godkänner fullmakten ovan och ger Lumidiom AB rätt att agera å mina vägnar.',
        sign_button: 'Signera digitalt',
        signing: 'Signerar...',
        signed_title: 'Fullmakt Signerad',
        signed_desc: 'Din fullmakt är aktiv. Vi kan nu agera å dina vägnar.',
        signed_at: 'Signerad',
        version_label: 'Version',
        status_active: 'Aktiv',
        error: 'Kunde inte signera fullmakten. Försök igen.',
        security_note: 'Din signatur registreras säkert med tidstämpel och IP-adress.',
        banner_title: 'Signera din fullmakt',
        banner_desc: 'Vi behöver din fullmakt för att kunna börja ta bort dina uppgifter från nätet.',
        banner_cta: 'Signera nu'
    }
};
